import axiosInstance from './AxiosInstance'; // Path to your Axios instance

const ScacTypeService = {
  fetchScacType : async (page, pageSize, sortBy, order,searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", 
    };
    
    try {
      const response = await axiosInstance.get('/scacType', {
        params:queryObj , // Query parameters
      });
      console.log("response===========",response);
      
      return response.data;
    } catch (error) {
      console.error("Error fetching SCAC types:", error);
      throw error;
    }
  },

createSCACType: async (data) => {
  try {
    const response = await axiosInstance.post('/scacType', data);
    return response.data;
  } catch (error) {
    console.error('Error creating SCACType:', error);
    throw error;
  }
},

updateSCACType: async (id, data) => {
  try {
    const response = await axiosInstance.put(`/scacType/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating SCACType with ID ${id}:`, error);
    throw error;
  }
},

deleteSCACType: async (id) => {
  try {
    const response = await axiosInstance.delete(`/scacType/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting SCACType with ID ${id}:`, error);
    throw error;
  }
}
};

export default ScacTypeService;